'use strict';

var router = require('react-router');

module.exports = router;
